module.exports = __webpack_public_path__ + "static/media/HFB-logo.fdca500b.png";